import React from 'react';
import { ReactComponent as Logo } from '../Images/logo.svg';
import {ReactComponent as Knapsack} from '../Images/knapsack.svg';
import {ReactComponent as Cash} from '../Images/coin-cash.svg';
import {ReactComponent as Card} from '../Images/card.svg';
import {ReactComponent as Phone} from '../Images/phone.svg';
import { Footer } from '../Components/Footer';

export const Home = () => {
  return (
    <>
      {/* For Mobile Devices  */}
      <div className="lg:hidden pt-1">
        <div className='bg-[#e2f6ff] h-96'>
          <div className="flex justify-center items-center pt-5">
            <Logo />
          </div>
          <p className='text-center pt-2'>Spend your assets hassle free in real time!</p>
          <div className="grid justify-center items-center pt-5">
            <a href="https://forms.gle/iu9npMxuc3YiQCax5"><button className="bg-[#0e719c] text-white px-2 py-1 ml-[7.5rem] mt-4 rounded-md">Join the Waitlist</button></a>
            <Knapsack className='w-40 pb-40 mx-[6.5rem]'/>
          </div>
        </div>
        <div>
          <p className='text-center pt-8 text-lg font-bold'>Convert your assets into</p>
          <p className='text-center text-lg font-bold'>cash real time!</p>
          <p className='text-center pt-4'>Get the best value of your assets by real</p>
          <p className='text-center'>time conversion of your assets to cash!</p>
          <div className='flex justify-center items-center'>
            <Cash className='w-60'/>
          </div>
          <p className='text-center text-xl font-bold'>One swipe to send your</p>
          <p className='text-center text-xl font-bold'>assets!</p>
          <p className='text-center pt-4'>Customized SpendVest card for one swipe</p>
          <p className='text-center'>transactions!</p>
          <div className='flex justify-center items-center'>
            <Card className='w-60'/>
          </div>
          <p className='text-center text-lg font-bold'>Keep track of your assets in one</p>
          <p className='text-center text-lg font-bold'>place!</p>
          <p className='text-center pt-4'>Invest, track and spend using our</p>
          <p className='text-center'>app!</p>
          <div className='flex justify-center items-center'>
            <Phone className='w-60'/>
          </div>
        </div>
      </div>

      {/* For Desktop  */}
      <div className='hidden lg:block'>
        <div className="bg-[#e2f6ff] h-[30rem]" >
          <div className='px-5'>
            <div className='flex flex-row justify-center items-center'>
              <div className='lg:ml-4 lg:mt-6'>
                <Logo className='lg:w-72' />
                <p className='lg:ml-7 lg:pt-3 lg:text-xl'>Spend your assets hassle free in real time!</p>
                <a href="https://forms.gle/iu9npMxuc3YiQCax5" target='_blank' rel='noreferrer' ><button className="bg-[#0e719c] text-white px-5 py-1 ml-7 mt-5 rounded-md">Join the Waitlist</button></a>
              </div>
              <div className='ml-60 pt-16'>
                <Knapsack className='w-60'/>
              </div>
            </div>
          </div>
        </div>
        <div className='px-5'>
          <div className="flex flex-row justify-center items-center">
            <div>
              <p className='ml-10 text-4xl mt-20 font-bold'>Convert your assets</p>
              <p className='ml-10 text-4xl mt-2 font-bold'>into cash real time!</p>
              <p className='ml-10 text-lg mt-10 font-medium'>Get the best value of your assets</p>
              <p className='ml-10 text-lg font-medium'>by real time converion of your</p>
              <p className='ml-10 text-lg font-medium'>assets to cash!</p>
            </div>
            <div className='ml-60 pt-16'>
              <Cash className='w-60'/>
            </div>
          </div>
        </div>
        <div className='px-5'>
          <div className="flex flex-row justify-center items-center">
            <div className='-ml-10 mt-16'>
              <Card className='w-72'/>
            </div>
            <div>
              <p className='ml-32 text-4xl mt-20 font-bold'>One swipe to spend</p>
              <p className='ml-32 text-4xl mt-2 font-bold'>your assets!</p>
              <p className='ml-32 text-lg mt-10 font-medium'>Customized SpendVest card for</p>
              <p className='ml-32 text-lg font-medium'>one swipe transactions!</p>
            </div>
          </div>
        </div>
        <div className='px-5'>
          <div className="flex flex-row justify-center items-center">
            <div>
              <p className='ml-10 text-4xl mt-20 font-bold'>Keep track of your</p>
              <p className='ml-10 text-4xl mt-2 font-bold'>assets in one place!</p>
              <p className='ml-10 text-lg mt-10 font-medium'>Invest, track and spend using our</p>
              <p className='ml-10 text-lg font-medium'>app!</p>
            </div>
            <div className='ml-60 pt-16'>
              <Phone className='w-60'/>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}